import { Injectable } from '@angular/core';
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { MmDialogService } from '@metromarkets/components';
import { ImpersonationActiveAlertDialog } from '~shared/components/impersonation-active-alert-dialog/impersonation-active-alert-dialog.component';
import { AccountInfoService } from '../modules/identity/services/account-info.service';
import { filter, map, take } from 'rxjs/operators';
import { NUMBER_1 } from '~shared/constants';
import { AccountType } from '~shared/models';

@Injectable({
  providedIn: 'root',
})
export class EmployeeRedirectionPromptGuard implements CanDeactivate<unknown> {
  constructor(private readonly mmDialogService: MmDialogService, private accountInfoService: AccountInfoService) {}

  canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const checkIsImpersonated$ = this.accountInfoService.accountType$.pipe(
      filter((accountType) => accountType !== null),
      take(NUMBER_1),
      map((accountType) => [AccountType.EMPLOYEE_AS_CUSTOMER].includes(accountType)),
      map((checkIsImpersonated) => {
        if (checkIsImpersonated) {
          this.mmDialogService.open(ImpersonationActiveAlertDialog);
          return false;
        }
        return true;
      })
    );

    return checkIsImpersonated$;
  }
}
